import React from 'react';
import { SwipeableDrawer } from '@mui/material';
import { PDFViewer } from '@react-pdf/renderer';
import InvoicePDF from '../sections/@dashboard/invoice/details/InvoicePDF';
import StockTransferPDF from '../components/print/StockTransferPDF'

const PdfViewerDrawer = ({ open, onClose, invoice, paymentVoucher = {}, workflowLog = [] }) => {
  let type = 'INVOICE'
  if (invoice?.pdfType === "STOCK_TRANSFER") {
    type = 'STOCK_TRANSFER'
  } else {
    type = 'INVOICE'
  }


  return (
    <SwipeableDrawer
      anchor='bottom'
      open={open}
      onOpen={() => { }}
      onClose={onClose}
      PaperProps={{
        sx: {
          marginLeft: '5%',
          width: '90%',
          height: '90%',
        },
      }}
    >
      {type == 'INVOICE' &&  invoice?.items &&
        <PDFViewer style={{ width: '100%', height: '100%' }}>
          <InvoicePDF invoice={invoice} paymentVoucher={paymentVoucher} workflowLog={workflowLog}/>
        </PDFViewer>
      }
      {type == 'STOCK_TRANSFER' &&
        <PDFViewer style={{ width: '100%', height: '100%' }}>
          <StockTransferPDF key={invoice.transferId} transfer={invoice} />
        </PDFViewer>
      }
    </SwipeableDrawer>
  );
};

export default PdfViewerDrawer;
